export const REQUEST_LIST_COURSES  = 'request_list_courses'
export const LIST_COURSES_SUCCESS = 'list_courses_success'
export const LIST_COURSES_FAILURE = 'list_courses_failure'

export const CLEAR_LIST_COURSES = 'clear_list_courses'